import axios from 'axios';

const getUser = async () => {
    try {
        const token = localStorage.getItem('token'); // Substituindo AsyncStorage por localStorage
        if (!token) {
            throw new Error('Token não encontrado');
        }

        const response = await axios.get('https://apem.riderup.uk/api/user', {
            headers: { Authorization: `Bearer ${token}` }
        });

        if (response.data) {
            return response.data;
        } else {
            throw new Error('Falha ao buscar dados do usuário');
        }
    } catch (error) {
        console.error('Erro ao buscar dados do usuário:', error);
        throw error;
    }
};

export default getUser;
